import { CommonModule } from '@angular/common';
import {
  Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit
} from '@angular/core';
import { isEmpty } from '@app/util/util';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { SnackbarSize, SnackbarType } from '@design-system/components/molecules/snackbar/entities/snackbar.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent,
  ]
})
export class SnackbarDsComponent implements AfterViewInit {

  @Input() size = SnackbarSize.SM;
  @Input() type = SnackbarType.Notification;
  @Input() message: string;
  @Input() action: string;
  @Input() icon: Icon;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('snackbarDs', { static: true }) public snackbarDs: ElementRef;

  public readonly fontColor = TypographyColor.Invert;
  public readonly fontFamily = TypographyFontFamily.SemiBold;

  constructor() { }

  ngAfterViewInit(): void {
    this.addClickEvent();
  }

  get fontSize(): TypographyFontSize {
    return this.size === SnackbarSize.SM ? TypographyFontSize.XXS : TypographyFontSize.XS;
  }

  get snackbarIcon(): Icon {
    switch (this.type) {
      case SnackbarType.Error:
        return Icon.Info;
      case SnackbarType.Warning:
        return Icon.Warning;
      case SnackbarType.Success:
        return Icon.Check;
      default:
        return this.icon;
    }
  }

  get iconFillColor(): IconFillColor {
    switch (this.type) {
      case SnackbarType.Error:
        return IconFillColor.Error;
      case SnackbarType.Warning:
        return IconFillColor.Warning;
      case SnackbarType.Success:
        return IconFillColor.Success;
      default:
        return IconFillColor.Light;
    }
  }

  public clickedSnackbar(emit: boolean): void {
    if (emit) {
      this.clickEvent.emit();
    }
  }

  private addClickEvent(): void {
    if (this.snackbarDs?.nativeElement) {
      this.snackbarDs?.nativeElement?.addEventListener('click', () => {
        this.clickedSnackbar(isEmpty(this.action));
      });
    }
  }

}
